/*! @azure/msal-common v15.14.2 2026-02-10 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.14.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
